<mat-card appearance="outlined" class="rag-card">
  <form [formGroup]="form" class="rag-form">
    <mat-form-field>
      <mat-label>ChatHub URL</mat-label>
      <input
        formControlName="chatHubUrl"
        matInput
        [readonly]="state.isRunning"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Number of ChatHub connections</mat-label>
      <input
        formControlName="connectionCount"
        matInput
        type="number"
        min="1"
        [readonly]="state.isRunning"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Delay between new connections (ms)</mat-label>
      <input
        formControlName="delayMs"
        matInput
        type="number"
        min="0"
        [readonly]="state.isRunning"
      />
    </mat-form-field>
  </form>

  <div class="rag-actions">
    <button
      type="button"
      mat-raised-button
      [color]="state.isRunning ? 'warn' : 'primary'"
      [class.stop-load-test-button]="state.isRunning"
      (click)="toggleLoadTest()"
    >
      {{ state.isRunning ? 'Stop signal-r load test' : 'Start signal-r load test' }}
    </button>

    <button
      type="button"
      mat-stroked-button
      (click)="downloadLogs()"
      [disabled]="state.logEntries === 0"
    >
      Download logs
    </button>

    <button
      type="button"
      mat-stroked-button
      (click)="resetStatisticsAndLogs()"
      [disabled]="state.isRunning"
    >
      Reset statistics and clear logs
    </button>
  </div>

  @if (state.startedAt) {
  <div class="rag-timestamps">
    <span>Started: {{ state.startedAt | date: 'medium' }}</span>
    @if (!state.isRunning && state.stoppedAt) {
    <span>Stopped: {{ state.stoppedAt | date: 'medium' }}</span>
    }
  </div>
  }

  <div class="rag-metrics">
    <mat-card appearance="outlined" class="metric-card metric-card-no-limit">
      <span class="metric-label">Connections created</span>
      <span class="metric-value">{{ state.createdConnections }}</span>
    </mat-card>

    <mat-card appearance="outlined" class="metric-card metric-card-no-limit">
      <span class="metric-label">Connections pending</span>
      <span class="metric-value">{{ state.scheduledConnections }}</span>
    </mat-card>

    <mat-card appearance="outlined" class="metric-card metric-card-no-limit">
      <span class="metric-label">Connected threads</span>
      <span class="metric-value">{{ state.connectedConnections }}</span>
    </mat-card>

    <mat-card
      appearance="outlined"
      class="metric-card"
      [class.metric-card-limit-exceeded]="state.notConnectedConnections > 0"
      [class.metric-card-within-limit]="state.notConnectedConnections <= 0"
    >
      <span class="metric-label">Not connected threads</span>
      <span class="metric-value">{{ state.notConnectedConnections }}</span>
    </mat-card>

    <mat-card
      appearance="outlined"
      class="metric-card"
      [class.metric-card-limit-exceeded]="state.reconnectionAttempts > 0"
      [class.metric-card-within-limit]="state.reconnectionAttempts <= 0"
    >
      <span class="metric-label">Reconnect attempts</span>
      <span class="metric-value">{{ state.reconnectionAttempts }}</span>
    </mat-card>

    <mat-card
      appearance="outlined"
      class="metric-card"
      [class.metric-card-limit-exceeded]="state.reconnectingConnections > 0"
      [class.metric-card-within-limit]="state.reconnectingConnections <= 0"
    >
      <span class="metric-label">Reconnecting now</span>
      <span class="metric-value">{{ state.reconnectingConnections }}</span>
    </mat-card>

    <mat-card appearance="outlined" class="metric-card metric-card-no-limit">
      <span class="metric-label">Successful reconnects</span>
      <span class="metric-value">{{ state.successfulReconnections }}</span>
    </mat-card>

    <mat-card
      appearance="outlined"
      class="metric-card"
      [class.metric-card-limit-exceeded]="state.failedConnections > 0"
      [class.metric-card-within-limit]="state.failedConnections <= 0"
    >
      <span class="metric-label">Failed starts</span>
      <span class="metric-value">{{ state.failedConnections }}</span>
    </mat-card>

    <mat-card appearance="outlined" class="metric-card metric-card-no-limit">
      <span class="metric-label">Log entries</span>
      <span class="metric-value">{{ state.logEntries }}</span>
    </mat-card>
  </div>
</mat-card>
